import OperatorGetParamsSiteOpenApiModel = OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel;
import OperatorGetParamsOperatorOpenApiModel = OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel;
import {ForwardGroupsInterface} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/ForwardGroupsInterface";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";
import {__} from "~/ts/library/Translate";

export default function getOperatorGroupsForForward(site: OperatorGetParamsSiteOpenApiModel, filterOperator?: (operator: OperatorGetParamsOperatorOpenApiModel) => boolean): ForwardGroupsInterface[] {
    let groups: ForwardGroupsInterface[] = [];
    if (OperatorAccountStore.data.value.accessRights.canForwardOnAllOperators) {
        let allOperators = OperatorAccountStore.data.value.operators
            .filter(operator => OperatorAccountStore.getOperatorStatus(operator.login, site.id).statusId != OPERATOR_STATUS_OFFLINE && operator.isWorkingNow);
        if (filterOperator) {
            allOperators = allOperators.filter(filterOperator);
        }
        let operatorsLoginsWithGroups: string[] = [];
        for (let group of site.groups) {
            let operators = allOperators.filter(operator => group.operators.indexOf(operator.login) > -1);
            operatorsLoginsWithGroups.push(...operators.map(operator => operator.login));
            groups.push({
                id: group.id,
                descr: group.descr,
                operators
            });
        }
        groups.push({
            id: null,
            descr: __("Вне отделов"),
            operators: allOperators
                .filter(operator => site.operators.indexOf(operator.login) > -1 && operatorsLoginsWithGroups.indexOf(operator.login) == -1)
        });
        let canForwardOnAll = OperatorAccountStore.checkAccess(
            OperatorAccountStore.data.value.accessRights.canForwardOnAllOperators,
            site.id
        );
        groups = groups.filter(group => {
            if (group.operators.length > 0) {
                if (canForwardOnAll || group.operators.find(item => item.login == OperatorAccountStore.login.value)) {
                    return true;
                }
            }
            return false;
        });
    }
    return groups;
}